
import { Base } from '../base-component';

import './attachments.component.scss';

export class Attachments extends Base {

	svg: string;
	downloadItems: Element[];

	constructor(element: Element){
		super(element);
	}

	init() {

		// Check for browsers that do not support "stroke-dasharray"
		const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);
		let svgDashArray = '';

		if (!isIE) {
			svgDashArray = 'stroke-dasharray="48"';
		}

		this.svg = `<svg class="attachments__checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><circle class="attachments__checkmark-circle" cx="48" cy="48" r="48" fill="none" /><path class="attachments__checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" ${svgDashArray} /></svg>`;

		this.downloadItems = Array.from(this.element.querySelectorAll('.js-download-items'));

	}

	bindEvents() {

		this.downloadItems.map((item) => item.addEventListener('click', (event) => {

			this.markAsDownloaded(event);

		}));

	}

	markAsDownloaded(event) {

		if (!event.currentTarget.classList.contains('js-downloaded-item')) {

			event.currentTarget.classList.add('js-download-item');

			this.showDownloadedIndicator();

		}

	}

	showDownloadedIndicator() {

		let downloadedItem = this.element.querySelector('.js-download-item');
		let downloadedIndicator = downloadedItem.querySelector('.attachments__indicator');
		let downloadedItemIcon = downloadedItem.querySelector('.attachments__icon-container');

		downloadedIndicator.classList.add('attachments__indicator--complete');
		downloadedItemIcon.classList.add('attachments__icon-container--hidden');

		setTimeout(() => {

			downloadedItem.querySelector('.attachments__indicator').innerHTML = this.svg;
			downloadedItem.classList.add('js-downloaded-item');
			downloadedItem.classList.remove('js-download-item');

		}, 250);

	}

}



// WEBPACK FOOTER //
// ./components/attachments/attachments.component.ts